import styled from 'styled-components';

import { greenLight, greenLightest } from 'styles/colors';
import { mMedium, xxxlMedium } from 'styles/typography';

export const ErrorWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	min-height: 100vh;
	justify-content: center;
`;

export const Title = styled.label`
	margin-bottom: 70px;
	color: ${greenLight};
	${xxxlMedium};
`;

export const ErrorType = styled.p`
	text-transform: uppercase;
	margin-bottom: 10px;
	${mMedium};
`;

export const Description = styled.p`
	max-width: 600px;
	${mMedium};
`;

export const Button = styled.button`
	border-radius: 1px;
	background-color: ${greenLightest};
	height: 56px;
	width: 281px;
	margin-top: 50px;
	border: none;
	cursor: pointer;
`;
